export default __webpack_public_path__ + "static/media/297.b4d6dbf6.png";